import { autoserializeAs } from 'cerialize';
import { ConfigurationValue } from './configuration-value';

export class AutoPairGlobalConfiguration {
  @autoserializeAs(ConfigurationValue)
  reliabilityOTPWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  reliabilityDNSWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  reliabilityLDCWeight: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  experiencedRideCount: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  daysBetweenDriverStatistics: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  daysBetweenDriverScores: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  reservationsForReliabilityScore: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  daysForSafetyTracking: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  reservationsForReputationScore: ConfigurationValue;
}
